import { ReactNode } from 'react';
import styles from './ContentCard.module.css';

interface ContentCardProps {
  children: ReactNode;
}

export const ContentCard = ({ children }: ContentCardProps) => (
  <div className={styles.root}>{children}</div>
);
